import store from '@/store'
import {$skutopia} from '@axios'
import { transformRequestOptions } from '@core/utils'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchPOGs(ctx, queryParams) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .get('/planograms/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        fetchPOG(ctx, id, queryParams) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .get(`/planograms/${id}/`, {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        addPOG(ctx, payload) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .post(`/planograms/excel/upload/`,
                    payload,
                    {
                        headers: {
                        'Content-Type': 'multipart/form-data' // Optional, but recommended
                        }
                    }
                )
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        editPOG(ctx, {id, payload}) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .patch(`/planograms/${id}/`,
                    payload,
                    {
                        headers: {
                        'Content-Type': 'multipart/form-data' // Optional, but recommended
                        }
                    }
                )
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        deletePOG(ctx, id) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .delete(`/planograms/${id}/`)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        
        downloadImages(ctx, payload) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .post(`/catalog/skus/download/`, payload, { responseType:'blob', })
                .then(response => {
                    resolve(response)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        downloadMissingProducts(ctx, id ) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .get(`/planograms/${id}/missing/`, { responseType:'blob', })
                .then(response => {
                    resolve(response)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        downloadDOCXProducts(ctx, id ) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .get(`/planograms/${id}/docx/`, { responseType:'blob', })
                .then(response => {
                    resolve(response)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        downloadPOGXLSX(ctx, id ) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .get(`/planograms/${id}/pog_xlsx/`, { responseType:'blob', })
                .then(response => {
                    resolve(response)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        downloadPOGPSD(ctx, id ) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .get(`/planograms/${id}/psd/`, { responseType:'blob',})
                .then(response => {
                    resolve(response)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        downloadPNG(ctx, {id, sides} ) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .get(`/planograms/${id}/png/`, { responseType:'blob',
                    params: {sides},
                    paramsSerializer: params => transformRequestOptions(params) })
                .then(response => {
                    resolve(response)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        downloadDecipherPNG(ctx, {id, sides} ) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .get(`/planograms/${id}/decipher/`, { responseType:'blob',
                    params: {sides},
                    paramsSerializer: params => transformRequestOptions(params) })
                .then(response => {
                    resolve(response)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        addPOGShelfImage(ctx, payload) {
            const formImageData = new FormData()
            formImageData.append('shelf_image', payload.file)
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .patch(`/planograms/${payload.id}/`,
                    formImageData,
                    {
                        headers: {
                          'Content-Type': 'multipart/form-data' 
                        }
                    }
                )
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        fetchProducts(ctx, queryParams) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .get('/catalog/products/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        fetchProduct(ctx, id, queryParams) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .get(`/catalog/products/${id}/`, {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        updateProduct(ctx, payload) {
            store.commit('app/LOADING', true)
            const formData = new FormData()
            formData.append('data', JSON.stringify(payload))
            return new Promise((resolve, reject) => {
                $skutopia()
                .patch(`/catalog/products/${payload.barcode}/`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        addProduct(ctx, payload) {
            store.commit('app/LOADING', true)
            const formData = new FormData()
            formData.append('data', JSON.stringify(payload))
            return new Promise((resolve, reject) => {
                $skutopia()
                .post(`/catalog/products/`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        deleteProduct(ctx, id) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .delete(`/catalog/products/${id}/`)
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        addBulkProductsInfo(ctx, payload) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .post('/catalog/products/upload_excel/',
                    payload,
                    {
                        headers: {
                        'Content-Type': 'multipart/form-data' // Optional, but recommended
                        }
                    }
                )
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        addBulkProductImages(ctx, payload) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $skutopia()
                .post('/catalog/images/upload/',
                    payload,
                    {
                        headers: {
                        'Content-Type': 'multipart/form-data' // Optional, but recommended
                        }
                    }
                )
                .then(response => {
                    store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => {
                    store.commit('app/LOADING', false)
                    reject(error)
                })
            })
        },
        fetchMarkets(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                $skutopia()
                .get('/core/countries/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        addBrand(ctx, payload) {
            return new Promise((resolve, reject) => {
                $skutopia()
                .post('/core/brands/', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        fetchBrands(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                $skutopia()
                .get('/core/brands/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        addCategory(ctx, payload) {
            return new Promise((resolve, reject) => {
                $skutopia()
                .post('/core/categories/', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        fetchCategories(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                $skutopia()
                .get('/core/categories/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        fetchProjCategories(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                $skutopia()
                .get('/planograms/categories/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        fetchSpecs(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                $skutopia()
                .get('/catalog/specifications/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        updatePOGProduct(ctx, payload) {
            return new Promise((resolve, reject) => {
            $skutopia()
                .patch(`/planograms/pog_products/${payload.id}/`, {
                ...payload
                })
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
                })
            })
        },
        fetchBulkProducts(ctx, barcodes) {
            store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
            $skutopia()
                .get('/catalog/products/bulk-search/', {
                params: { barcodes: barcodes.join(',') }
                })
                .then(response => {
                store.commit('app/LOADING', false)
                resolve(response.data)
                })
                .catch(error => {
                store.commit('app/LOADING', false)
                reject(error)
                })
            })
        },

        fetchProductFacets(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                $skutopia()
                .get('/catalog/products/facets/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },

        exportCatalog(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                $skutopia()
                .get('/catalog/products/export_catalog/', {
                    params: queryParams,
                    responseType: 'blob',
                    paramsSerializer: params => transformRequestOptions(params)
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
    }
}